import {
  GET_SKILLSET_OPTIONS_OF_TYPE,
  GET_SKILLSET_OPTIONS_OF_TYPE_SUCCESS,
  RESET_SKILLSET_STATE,
} from './actionTypes';

export const getSkillsetOfType = skillsetType => ({
  type: GET_SKILLSET_OPTIONS_OF_TYPE,
  skillsetType,
});

export const getSkillsetOfTypeSuccess = (skillsetType, value) => ({
  type: GET_SKILLSET_OPTIONS_OF_TYPE_SUCCESS,
  skillsetType,
  value,
});

export const resetSkillsetState = () => ({
  type: RESET_SKILLSET_STATE,
});
